export default __webpack_public_path__ + "static/media/play-circle.0af0b3ef.svg";